// This is just an example,
// so you can safely delete all default props below

export default {
    signup: 'Register user for boat booking solution.',
    signup_desc: 'NB! a user account/login to the boat booking solution is optional to have/use to buy/reserve boat tickets.<br/>NB! login to MyPage at kolumbus.no can not be used here.',
    given_name: 'First Name',
    family_name: 'Last Name',
    address_line_1: 'Address',
    postal_code: 'Postal Code',
    locality: 'City',
    country_code: 'Country',
    phone_number: 'Mobile Phone',
    email: 'Email',
    email_repeat: 'Repeat Email',
    password: 'Password',
    password_repeat: 'Repeat Password',
    error_given_name: 'First name must be supplied',
    error_family_name: 'Last name must be supplied',
    error_address_line_1: 'Address must be supplied',
    error_postal_code: 'Postal code must be supplied',
    error_locality: 'City must be supplied',
    error_country_code: 'Country must be supplied',
    error_phone_number: 'Mobile phone number is not valid',
    error_email: 'Email is not valid',
    error_email_repeat: 'Email repeated must be the same with email',
    error_password: 'The password must be at least 8 characters, and must contain uppercase / lowercase letters, numbers and symbols.',
    error_password_repeat: 'Password repeat must be the same as new password.',
    error_email_exist: 'Email is already in use',
    signup_success: 'Account registration successful',
    signup_success_desc: 'Welcome. Your account has been created and you are now logged in.'
}
